import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { formatMoney } from 'accounting';

import itemTypePluralize from '../../common/itemTypePluralrize';
import FinanceSummaryData from '../../../models/FinanceSummaryData';

class SummaryTable extends React.PureComponent {
  render() {
    const { summaryData, header } = this.props;


    const getColor = (value) => {
      if (value === 0) {
        return 'rgb(0, 0, 0;)';
      }


      return value >= 0 ? 'rgb(12, 202, 12)' : 'rgb(204, 11, 11)';
    };

    /* eslint-disable react/prop-types */
    const columns = [
      {
        Header: 'Type',
        accessor: 'cat',
        PivotValue: row => <span>{itemTypePluralize(row.value)}</span>,
      },
      {
        Header: 'Subtype',
        accessor: 'attributeValue',
        Aggregated: () => {},
        Footer: <div style={{ fontWeight: 'bold', textAlign: 'center' }}>Totals:</div>,
      },
      {
        Header: 'Items',
        accessor: 'count',
        aggregate: vals => _.sum(vals),
        Footer: <div style={{ fontWeight: 'bold' }}>{_.sumBy(summaryData, 'count')}</div>,
      },
      {
        Header: 'Value',
        accessor: 'totalValue',
        aggregate: vals => _.sum(vals),
        Cell: props => <span>{formatMoney(props.value)}</span>,
        Footer: (
          <div style={{ fontWeight: 'bold' }}>
            {formatMoney(_.sumBy(summaryData, 'totalValue'))}
          </div>
        ),
      },
      {
        Header: 'Gain / Loss',
        accessor: 'gain',
        aggregate: vals => _.sum(vals),
        Cell: props => (
          <span style={{ color: getColor(props.value) }}>
            {formatMoney(props.value)}
          </span>
        ),
        Footer: () => {
          const total = _.sumBy(summaryData, 'gain');
          return (
            <span style={{ color: getColor(total) }}>
              {formatMoney(total)}
            </span>
          );
        },
      },
    ];
    /* eslint-enable react/prop-types */

    return (
      <div>
        {header && <h4 className="subtitle is-4">{header}</h4>}
        <ReactTable
          data={summaryData}
          columns={columns}
          pivotBy={['cat']}
          showPageSizeOptions={false}
          showPageJump={false}
          defaultPageSize={10}
          minRows={1}
        />
      </div>
    );
  }
}

SummaryTable.propTypes = {
  summaryData: PropTypes.arrayOf(PropTypes.instanceOf(FinanceSummaryData)),
  header: PropTypes.string,
};

SummaryTable.defaultProps = {
  summaryData: [],
  header: '',
};
export default SummaryTable;



// WEBPACK FOOTER //
// ./src/components/pages/financials/SummaryTable.jsx